import { createColDef } from '@fortem-monorepo/react-ag'

import { TraderIdCellEditor } from '@/ag-grid/columns/trader-id/cell-editor'
import { TraderIdCellRenderer } from '@/ag-grid/columns/trader-id/renderer'

export const trader_id = createColDef({
  field: 'trader_id',
  headerName: 'Trader',
  cellRenderer: TraderIdCellRenderer,
  cellEditor: TraderIdCellEditor,
  width: 200,
})
